// White-label data-source names so end users never see which providers power lookups.
const GENERIC = 'Samaritan Intelligence';

const MAP = [
  [/attom/i, 'Property Records'],
  [/google\s*solar|pvwatts|nrel/i, 'Roof & Solar Analysis'],
  [/shovels/i, 'Permit Network'],
  [/open\s*(permit|data)|city permit|county/i, 'Permit Network'],
  [/dns|mx\b/i, 'Email Deliverability'],
  [/email\s*pattern|pattern analysis/i, 'Email Intelligence'],
  [/area\s*code|carrier|line type/i, 'Phone Intelligence'],
  [/twilio|numverify|numlookup/i, 'Carrier Verification'],
  [/census|acs/i, 'Demographic Data'],
  [/eia/i, 'Utility Rate Data'],
  [/pluto|opa|assessor|tax roll|public record/i, 'Public Property Records'],
  [/whitepages|truepeople|fastpeople|spokeo|people\s*search/i, 'Contact Intelligence'],
];

export function sanitizeSource(s) {
  if (!s) return GENERIC;
  for (const [re, label] of MAP) {
    if (re.test(String(s))) return label;
  }
  return GENERIC;
}

export function sanitizeSources(arr) {
  if (!arr || !arr.length) return [];
  return [...new Set(arr.map(sanitizeSource))];
}
